import { IGroup } from "@nju/data-access-portal-dashboard";
import { IMemberOrchestrators } from "@nju/data-access-portal-member";
import { IOrchestrators } from "@nju/data-access-portal-orchestrator";

interface IReolveUserIdProps {
  adminId: string;
  mobileOrchestrator: IOrchestrators["mobile"] | IMemberOrchestrators["mobile"];
  multiOrderOrchestrator: IOrchestrators["multiOrder"];
  userIdFromQueryParams: string | undefined;
  members: IGroup["members"] | undefined;
  flow: string | undefined;
}

export function resolveUserId({
  mobileOrchestrator,
  adminId,
  userIdFromQueryParams,
  members,
  flow,
  multiOrderOrchestrator,
}: IReolveUserIdProps) {
  if (flow === "multiOrder" && multiOrderOrchestrator) {
    return;
  }

  if (userIdFromQueryParams) {
    const hasMember = members?.some((member) => {
      return member.id === userIdFromQueryParams;
    });

    if (!hasMember && members) {
      return members[0]?.id;
    }

    return userIdFromQueryParams;
  }

  if (!userIdFromQueryParams && members) {
    const adminMember = members?.find((member) => {
      return member.id === adminId;
    });

    if (!adminMember) {
      return members[0]?.id;
    }

    return adminMember?.id;
  }

  return mobileOrchestrator?.id;
}
